import { Box, Container, Typography, Avatar } from '@mui/material';
import logo from '../assets/logo.png';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#fff8ec',
        color: '#F9B233',
        py: 5,
        mt: 'auto',
        borderTop: '3px solid #F9B233',
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
          }}
        >
          <img  
            src={logo}
            alt="Restro360 Logo"
            style={{ width: '100px'}}
          />
          <Typography variant="body2" color="#F9B233" align="center">
            © {new Date().getFullYear()} Restro360. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer; 